import axiosInstance from "../../lib/axiosInstance";
import { toast } from "react-toastify";
import { AppDispatch } from "../store";
import { timetableJobActions as slice } from "../slices/timetableJob";
import { getErrorMessage } from "../../utils/errorUtils";
import { TimetableJobRequestDto } from "../../shared/dtos/timetableJob/TimetableJobRequestDto";
import { TimetableJobResponseDto } from "../../shared/dtos/timetableJob/TimetableJobResponseDto";
import { ApiResponseDto } from "../../shared/dtos/common/ApiResponseDto";
import { ApiResponseStatus } from "../../shared/enums/ApiResponseStatus";

export const startTimetableGeneration =
  (values: TimetableJobRequestDto) => async (dispatch: AppDispatch) => {
    dispatch(slice.resetTimetableJobState());
    dispatch(slice.setLoadingJobStart());

    try {
      const { data } = await axiosInstance.post<
        ApiResponseDto<TimetableJobResponseDto>
      >("/timetable-jobs", values, { headers: { requiresAuth: true } });

      if (
        data.status === ApiResponseStatus.SUCCESS ||
        data.statusCode === 202
      ) {
        toast.info("Generation started! Please wait...");
        if (data.data) {
          dispatch(slice.startJobSuccess(data.data));
        }
      }
    } catch (error) {
      const message = getErrorMessage(error);
      toast.error(message);
      dispatch(slice.setErrorStartingJob(message));
    }
  };

export const getJobStatus =
  (jobId: string) => async (dispatch: AppDispatch) => {
    dispatch(slice.setLoadingJobStatus());
    try {
      const { data } = await axiosInstance.get<
        ApiResponseDto<TimetableJobResponseDto>
      >(`/timetable-jobs/${jobId}`, { headers: { requiresAuth: true } });

      if (data.status === "SUCCESS" && data.data) {
        dispatch(slice.updateJobStatusSuccess(data.data));
      }
    } catch (error) {
      console.error("Polling error:", error);
      dispatch(slice.setErrorLoadingStatus(getErrorMessage(error)));
    }
  };

export const clearJobState = () => (dispatch: AppDispatch) => {
  dispatch(slice.resetTimetableJobState());
};
